import { createContext } from 'react';

const RequestsContext = createContext();

export default RequestsContext;
